<template>
  <div>
    <FlexiservisSettings :instanceId="instanceId"></FlexiservisSettings>
  </div>
</template>

<script>
import { get } from 'lodash'
import FlexiservisSettings from 'FLEXISERVIS/components/settings.vue'

export default {
    name: 'AddonsSettingsView',
    components: {
        FlexiservisSettings,
    },
    computed: {
        addonId() {
            return get(this.$route.params, 'addonId')
        },
        instanceId() {
            return get(this.$route.params, 'instanceId')
        },
    },
}
</script>
